import React from 'react'

const NoAppoint = () => {
  return (
    <div className='container-fluid d-flex align-items-center justify-content-center'>
        <h1>No Appointment Yet!!</h1>
    </div>
  )
}

export default NoAppoint